<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <div class="container py-5" id="elementPrint">
    <div class="p-4">
      <div class="row mb-3">
        <div class="col-md-6 d-flex justify-content-start align-items-end">
          <img
            src="../../assets/images/borneo-indobara-icon.png"
            alt=""
            style="width: 2.5rem; height: auto"
          />
          <b class="fs-8 w-100">PT BORNEO INDOBARA</b>
        </div>
        <div class="col-md-6 d-flex justify-content-end align-items-end">
          <b class="fs-8 fw-bold" style="text-align: right"
            >BIB-HSE-PPO-F-096-04</b
          >
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <p
            class="text-center mb-1 fs-5 fw-bold"
            style="font-family: 'Inter-Bold'; text-align: center"
          >
            SURAT PERNYATAAN CALON PJO
          </p>
          <p
            class="text-center fs-8"
            style="font-family: 'Inter-Regular'; text-align: center"
          >
            Formulir ini untuk menyatakan komitmen calon Penanggung Jawab
            Operasional
          </p>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-md-6">&nbsp;</div>
        <div class="col-md-6">
          <p for="nomor" class="form-label text-end fs-8">
            Nomor : {{ formValues.nomor }}
          </p>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-md-12">
          <p class="fs-8">Saya yang bertanda tangan di bawah ini:</p>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12 fs-8 ps-4">
          <table class="w-100 fs-8">
            <tbody>
              <tr>
                <td style="width: 15%">Nama</td>
                <td style="width: 5%">:</td>
                <td style="width: 80%">
                  {{ formValues.nama }} &nbsp; &nbsp; <i>(nama calon PJO)</i>
                </td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>
                  {{ formValues.jabatan }} &nbsp; &nbsp;
                  <i>(jabatan struktural calon PJO)</i>
                </td>
              </tr>
              <tr>
                <td>Perusahaan</td>
                <td>:</td>
                <td>{{ formValues.perusahaan }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
            Bahwa sesuai:
          </p>
          <ol type="1" class="fs-8 mb-3" style="font-family: 'Inter-Regular'">
            <li>
              Undang Undang No. 32 Tahun 2009 mengenai Perlindungan dan
              Pengelolaan Lingkungan Hidup
            </li>
            <li>
              Peraturan Menteri ESDM Nomor 26 Tahun 2018 tentang Pelaksanaan
              Kaidah Pertambangan yang Baik dan Pengawasan Pertambangan Mineral
              dan Batubara
            </li>
            <li>
              Keputusan Menteri ESDM Nomor 1827 K/30/MEM/2018 tentang Pedoman
              Pelaksanaan Kaidah Teknik Pertambangan yang Baik
            </li>
            <li>
              KepDirjen Minerba No. 185.K/37.04/DJB/2019 tentang Petunjuk Teknis
              Pelaksanaan Pertambangan dan Pelaksanaan, Penilaian, dan Pelaporan
              Sistem Manajemen Keselamatan Pertambangan Minerba
            </li>
          </ol>
          <p class="mt-3 mb-1 fs-8" style="font-family: 'Inter-Regular'">
            Menyatakan akan mematuhi peraturan di atas sesuai tugas dan tanggung
            jawab saya sebagai PJO, yaitu:
          </p>
          <ol type="1" class="fs-8" style="font-family: 'Inter-Regular'">
            <li>
              Membuat peraturan internal perusahaan mengenai penerapan kaidah
              teknik pertambangan yang baik mengacu kepada peraturan perusahaan
              pemegang IUP;
            </li>
            <li>
              Implementasi Sistem Manajemen Keselamatan Pertambangan (SMKP);
            </li>
            <li>
              Memastikan semua perusahaan jasa pertambangan yang beroperasi di
              bawahnya memenuhi kewajiban sesuai dengan ketentuan
              perundang-undangan;
            </li>
            <li>
              Menerapkan standar sesuai dengan ketentuan perundang-undangan;
            </li>
            <li>
              Menyampaikan laporan kegiatan jasa pertambangan kepada KTT sesuai
              dengan ketentuan perundang-undangan;
            </li>
            <li>
              Memiliki tenaga teknis pertambangan yang berkompeten sesuai dengan
              ketentuan perundang-undangan;
            </li>
            <li>
              Melaksanakan manajemen risiko pada setiap proses bisnis dan
              subproses kegiatan pertambangan;
            </li>
            <li>
              Menerapkan sistem manajemen keselamatan pertambangan dan melakukan
              pengawasan penerapan sistem manajemen keselamatan pertambangan
              yang dilaksanakan oleh perusahaan jasa pertambangan yang bekerja
              di wilayah tanggung jawabnya;
            </li>
            <li>
              Melaporkan penerapan kaidah teknik pertambangan yang baik kepada
              KTT, baik laporan berkala, akhir, dan/atau khusus sesuai dengan
              ketentuan perundang-undangan;
            </li>
            <li class="mt-135">
              Melaporkan pelaksanaan kegiatan pengelolaan dan pemantauan
              lingkungan secara berkala sesuai dengan bentuk yang ditetapkan;
            </li>
            <li>
              Melaporkan jumlah pengadaan, penggunaan, penyimpanan, dan
              persediaan bahan dan limbah berbahaya dan beracun secara berkala
              setiap 6 (enam) bulan atau kurang dari itu apabila diperlukan
              sesuai kebijakan Perusahaan.
            </li>
            <li>
              Melaporkan adanya gejala yang berpotensi menimbulkan pencemaran
              dan/atau perusakan lingkungan;
            </li>
            <li>
              Menyampaikan laporan kasus lingkungan paling lambat 1 x 24 (satu
              kali dua puluh empat) jam setelah terjadinya kasus lingkungan
              berikut upaya penanggulangannya;
            </li>
            <li class="mt-135">
              Menyampaikan pemberitahuan awal dan melaporkan kecelakaan,
              kejadian berbahaya, kejadian akibat penyakit tenaga kerja, dan
              penyakit akibat kerja;
            </li>
            <li>
              Menyampaikan laporan audit internal penerapan Sistem Manajemen
              Keselamatan Pertambangan mineral dan batubara;
            </li>
            <li>
              Melakukan penanggulangan pencemaran dan/atau perusakan lingkungan
              pada tempat yang berpotensi menimbulkan perusakan dan pencemaran
              lingkungan;
            </li>
            <li class="mt-135">Bertempat tinggal di lokasi kerja.</li>
            <li>
              Menghadiri rapat-rapat dan kegiatan Komite Keselamatan
              Pertambangan dan Lingkungan Hidup PT Borneo Indobara.
            </li>
          </ol>
        </div>
      </div>
      <div style="height: 10vh"></div>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8" style="font-family: 'Inter-Regular'">
            Demikian Surat Pernyataan ini dibuat untuk dipergunakan sebagaimana
            mestinya.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">&nbsp;</div>
        <div class="col-md-4">
          <p class="fs-8 mb-2 text-center" style="font-family: 'Inter-Regular'">
            {{
              formValues.tempat + ", " + moment(formValues.tanggal).format("LL")
            }}
          </p>

          <p class="mb-3 fs-8 text-center" style="font-family: 'Inter-Regular'">
            Yang Membuat Pernyataan,
          </p>
          <br /><br /><br /><br /><br />
          <p class="text-center fs-8 text-decoration-underline">
            <u>{{ formValues.namaTTD }}</u>
          </p>
        </div>
      </div>
      <p class="fs-8">
        * Dokumen ini wajib melampirkan materai di kolom tanda tangan.
      </p>
    </div>
  </div>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";

import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";
import Swal from "sweetalert2";
import printJS from "print-js";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_SIO_SET_PERNYATAANPJO,
  CMS_SIO_GET_PERNYATAANPJO,
  CMS_SIO_GET_DASHBOARD,
  CMS_DOWNLOAD,
  CMS_UPLOAD_USECASE,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
} from "../../constants.js";

const url_simpan = API_BASE_URL + CMS_SIO_SET_PERNYATAANPJO;
const url_get_pernyataanpjo = API_BASE_URL + CMS_SIO_GET_PERNYATAANPJO;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
// const url_upload = API_BASE_URL + CMS_UPLOAD
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
// const max_file_size = 5; // MB

import { reactive, ref } from "vue";

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(255,255,255)",
  },
  disabled: false,
});

const signature1 = ref(null);

export default {
  mixins: [GlobalDataMixin],
  name: "PrintFormSuratPermohonanPengesahanPJO",
  data() {
    return {
      sioID: null,
      idKelengkapan: null,
      isLoading: false,
      refIDForm: 3,
      idForm: null,
      formValues: {
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
      },
      url_icon: "",
      fileTtd: "",
      // fileAttachment: '',
      validasiFile: {
        typeTtd: false,
        sizeTtd: false,
        typeAtt: false,
        sizeAtt: false,
      },
      kontraktorID: null,
      statusSio: 0,
    };
  },
  mounted() {
    this.kontraktorID = parseInt(this.userData.kontraktorID);
    if (localStorage.getItem("sio_cms") != null) {
      this.sioID = JSON.parse(localStorage.getItem("sio_cms")).id;
      this.getSioDashboard(this.sioID);
      this.getSioID(this.kontraktorID);
      this.getKelengkapan(this.sioID);
    }

    if (localStorage.getItem("icon_kontraktor_cms") != null) {
      this.url_icon =
        API_BASE_URL +
        CMS_VIEW_IMAGE +
        JSON.parse(localStorage.getItem("icon_kontraktor_cms")).icon;
    }
    this.formValues.perusahaan =
      this.userData.kontraktorName != null
        ? this.userData.kontraktorName
        : null;
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              // this.onChangeArr(this.listDokumen,'statusFile',ret_dash[i].formStatus, ret_dash[i].id);
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getPernyataanPJO(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getPernyataanPJO(idform) {
      axios
        .get(url_get_pernyataanpjo + idform, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPernyataanPJO", response);
          let dt = response.data.data;

          if (dt != null) {
            this.formValues.nomor =
              dt.nomorKontraktor == null ? "" : dt.nomorKontraktor;
            // this.formValues.nama = dt.namaCalon==null?'':dt.namaCalon;
            // this.formValues.jabatan = dt.jabatan==null?'':dt.jabatan;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            this.formValues.tempat = dt.tempat == null ? "" : dt.tempat;
            // this.formValues.namaTTD = dt.namaPengesah==null?'':dt.namaPengesah;

            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }

            // if(dt.attachmentFile!=''&&dt.attachmentFile!=null){
            //   this.fileAttachment = dt.attachmentFile;
            // }
            this.$nextTick(function () {
              // DOM is now updated
              // `this` is bound to the current instance
              this.print();
            });
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getPernyataanPJO : " + error.message);
          console.error(
            "Error fetching data getPernyataanPJO :",
            error.message,
          );
        });
    },
    async simpanForm() {
      const tandaTangan = this.$refs.tandaTangan.files[0];
      // const fileAttachment = this.$refs.fileAttachment.files[0];
      var purs = [];
      var files = [];
      if (tandaTangan != null) {
        purs.push("form3");
        files.push(tandaTangan);
      }

      // if(fileAttachment!=null){
      //   purs.push('attachment');
      //   files.push(fileAttachment);
      // }

      let bodyJsonProfile = {};

      if (this.idForm != null) {
        bodyJsonProfile = {
          id: this.idForm,
          idSio: this.sioID,
          nomorKontraktor: this.formValues.nomor,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          namaPengesah: this.formValues.namaTTD,
          namaCalon: this.formValues.nama,
          jabatan: this.formValues.jabatan,
          reason: "",
          // "attachmentDelete": true
        };
      } else {
        bodyJsonProfile = {
          // "id": this.idForm,
          idSio: this.sioID,
          nomorKontraktor: this.formValues.nomor,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          namaPengesah: this.formValues.namaTTD,
          namaCalon: this.formValues.nama,
          jabatan: this.formValues.jabatan,
          reason: "",
          // "attachmentDelete": true
        };
      }

      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanForm : ", response);

          let idForm = response.data.data.id;

          if (files.length > 0 && purs.length > 0) {
            this.uploadFiles(files, purs, idForm);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanForm : ", error);
          alert("error simpanForm");
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },

    async uploadFiles(files, purs, idform) {
      for (var x in files) {
        // console.log(files[x])
        // console.log(purs[x])
        let file = files[x];
        let pur = purs[x];
        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", idform);
          formData.append("purpose", pur);
          formData.append("usecase", "ttd_form3");

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_usecase, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert(error.message);
            if (error.response.data != null) {
              alert(error.response.data.message);
            }
            this.isLoading = false;
            console.error("Error uploading file:", error);
            // this.$router.go(this.$router.currentRoute)
          }
        }
      }
      this.alertSukses();
    },
    clickSimpan() {
      this.isLoading = true;
      if (this.validasiForm()) {
        this.simpanForm();
      } else {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
      }
    },
    validasiForm() {
      if (
        this.formValues.nomor != "" &&
        this.formValues.nama != "" &&
        this.formValues.jabatan != "" &&
        this.formValues.tempat != "" &&
        this.formValues.tanggal != "" &&
        this.formValues.namaTTD != "" &&
        (this.fileTtd != "" || this.$refs.tandaTangan.value != "")
        // &&(this.fileAttachment!=""||this.$refs.fileAttachment.value!="")
      ) {
        return true;
      } else {
        return false;
      }
    },
    save(t) {
      console.log(signature1.value.save(t));
      console.log(signature1);
      console.log(signature1.value);
      state.disabled = true;
    },

    clear() {
      signature1.value.clear();
      state.disabled = false;
    },

    undo() {
      signature1.value.undo();
      state.disabled = false;
    },

    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Surat Pernyataan Calon PJO berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    // handleChangeFile(refFile) {
    //         let file = null
    //         if (refFile == "tandaTangan") {
    //             file = this.$refs.tandaTangan.files[0];
    //             console.log('Valid file:', file);
    //             if (file) {
    //                 // Check file type
    //                 if (file.type !== "image/jpg"&&file.type !== "image/jpeg"&&file.type !== "image/png") {
    //                     this.validasiFile.typeTtd = true
    //                     this.validasiFile.sizeTtd = false
    //                     this.$refs.tandaTangan.value = ""
    //                     return
    //                 }

    //                 // Check file size ({{max_file_size}}MB limit)
    //                 if (file.size > max_file_size * 1024 * 1024) {
    //                     this.validasiFile.typeTtd = false
    //                     this.validasiFile.sizeTtd = true
    //                     this.$refs.tandaTangan.value = ""
    //                     return
    //                 }

    //                 // Reset error messages if the file is valid
    //                 this.validasiFile.typeTtd = false
    //                 this.validasiFile.sizeTtd = false

    //                 // Handle the valid file as needed (e.g., store the file)
    //                 console.log('Valid file:', file);
    //             }
    //         }
    //         else if(refFile == "fileAttachment"){
    //           file = this.$refs.fileAttachment.files[0];
    //             console.log('Valid file:', file);
    //             if (file) {
    //                 // Check file type
    //                 if (file.type !== "application/pdf") {
    //                     this.validasiFile.typeTtd = true
    //                     this.validasiFile.sizeTtd = false
    //                     this.$refs.fileAttachment.value = ""
    //                     return
    //                 }

    //                 // Check file size ({{max_file_size}}MB limit)
    //                 if (file.size > max_file_size * 1024 * 1024) {
    //                     this.validasiFile.typeTtd = false
    //                     this.validasiFile.sizeTtd = true
    //                     this.$refs.fileAttachment.value = ""
    //                     return
    //                 }

    //                 // Reset error messages if the file is valid
    //                 this.validasiFile.typeTtd = false
    //                 this.validasiFile.sizeTtd = false

    //                 // Handle the valid file as needed (e.g., store the file)
    //                 console.log('Valid file:', file);
    //             }
    //         }

    //     },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      var dateNow = moment(new Date()).format("DDMMYYYY");
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log(filename);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Surat_Pernyataan_Calon_PJO_" + dateNow + ".pdf"; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.formValues.nama = ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          this.formValues.jabatan =
            ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          this.formValues.namaTTD =
            ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;

          // this.formValues.jabatanAtasan = ret_kel.jabatanAtasan;
          // this.formValues.fileTtdPjo = ret_kel.ttdPjo;
          if (ret_kel.ttdPjo != "" && ret_kel.ttdPjo != null) {
            this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    async print() {
      printJS({
        printable: "elementPrint", // ID of the element you want to print
        // printable : ['elementPrint1','elementPrint2'],
        type: "html", // 'html' or 'image'
        // header: 'Print Preview', // optional
        documentTitle: "Form 3", // optional
        font_size: "",
        // style:url_css
        style: `
          @media print {
            * {
                -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
                color-adjust: exact !important;                 /* Firefox 48 – 96 */
                print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
            }
            @page {
              size: A4; /* Set the paper size to A4 */
              // margin: 0; /* Remove default page margins */
            }
            #elementPrint {
              transform: scale(1.1); /* Set the default scale to 0.8 */
              transform-origin: top left; /* Set the transformation origin */
              font-family: Inter-Regular;
            }
            #page1{
              margin-bottom: 70vh;
            }
            .text-center {text-align: center!important;}
            .text-end {text-align: right!important;}
            .fs-4 {font-size: 1.5rem !important;}
            .fs-5 {font-size: 1.25rem !important;}
            .fs-6 {font-size: 1rem !important;}
            .fs-7 {font-size: 0.9rem !important;}
            .fs-8 {font-size: 0.8rem !important;}
            .fs-9 {font-size: 0.7rem !important;}
            p {margin-top: 0;
              // margin-bottom: 1rem;
            }
            h1 {font-size: 1.5rem;margin-bottom3px;}
            .mt-5 {margin-top: 3rem !important;}
            .mt-4 {margin-top: 2rem!important;}
            .mt-3 {margin-top: 1rem!important;}
            .mt-2 {margin-top: 0.5rem!important;}
            .mt-1 {margin-top: 0.25rem!important;}
            .mb-5 {margin-bottom: 3rem !important;}
            .mb-4 {margin-bottom: 2rem!important;}
            .mb-3 {margin-bottom: 1rem!important;}
            .mb-2 {margin-bottom: 0.5rem!important;}
            .mb-1 {margin-bottom: 0.25rem!important;}

            ol, ul {padding-left: 1rem;}
            .footer{
              margin-top:15rem;
            }
            li {display: list-item; margin-bottom 1rem}
            #div_syarat{
              margin-top:3rem;
            }
            #poin_f, .mt-135{
              margin-top:1.35rem;
            }
            .judul_table{
              margin-bottom:1rem;
            }
            .p-4 {padding: 1.5rem!important;}

            .table, .table tr th, .table tr td{
              border:0.25px #000000 solid;
              // background-color : #f8d7da;
              
            }
            .table tr th{
              background-color : #f8d7da;
            }
            .table tr td{
              padding-left:0.5rem;
            }
            .align-items-end {align-items: flex-end!important;}
            .d-flex {display: flex!important;}
            .align-items-center {align-items: center!important;}
            .align-items-start {align-items: flex-start!important;}
            .justify-content-center {justify-content: center!important;}
            .justify-content-start {justify-content: flex-start!important;}
            .justify-content-end {justify-content: flex-end!important;}
          }
        `,
      });
    },
  },
};
</script>
